import styled from 'styled-components';
import { transparentize } from 'polished';

export const ContentWrapperStyled = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	min-height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
	background-color: ${transparentize(0.25, 'white')};
	pointer-events: all;
	&:hover {
		cursor: pointer;
	}
`;

export const CenterContainerStyled = styled.div``;
